import { motion } from "framer-motion";
import OperatingFramework from "@/components/OperatingFramework";
import WhyOneHill from "@/components/WhyOneHill";
import CtaBanner from "@/components/CtaBanner";
import SupplyChainFlow from "@/components/SupplyChainFlow";
import Section, { SectionHeading } from "@/components/Section";

const PRINCIPLES = [
  { k: "People-first", v: "Trained, recruited, retained store teams" },
  { k: "SOP-driven", v: "No guesswork on the store floor" },
  { k: "MIS-led", v: "Decisions backed by daily data" },
  { k: "Compliance-aware", v: "Documentation & hygiene baked in" },
];

export default function Framework() {
  return (
    <div data-testid="page-framework" className="pt-[72px]">
      <Section id="framework-intro" bg="white">
        <SectionHeading
          eyebrow="Operating Framework"
          title={<>How we run <span className="text-[#99CC00]">operations.</span></>}
          sub="A clean, repeatable model for QC platforms and brands — from store launch to multi-city scale."
        />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {PRINCIPLES.map((p, i) => (
            <motion.div
              key={p.k}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="rounded-3xl bg-[#F7F8F5] border border-neutral-200 p-6"
            >
              <div className="text-xs font-mono uppercase tracking-[0.22em] text-[#99CC00] font-black">/ {String(i + 1).padStart(2, "0")}</div>
              <div className="mt-4 text-xl lg:text-2xl font-display font-black text-[#1F1F1F]">{p.k}</div>
              <div className="mt-2 text-sm text-neutral-600">{p.v}</div>
            </motion.div>
          ))}
        </div>
      </Section>

      <OperatingFramework />
      <SupplyChainFlow />
      <WhyOneHill />
      <CtaBanner title="Bring this playbook to your dark stores." cta="Partner With OneHill" />
    </div>
  );
}
